<template>
    <div>
        <b-card>
            <div class="d-flex justify-content-between">
                <b-card-title>Referências e Contrarreferências</b-card-title>
                <b-button size="xs" variant="default" @click="show = !show; getReferencias()" class="m-1">
                    Ver Referências e Contrarreferências
                </b-button>
            </div>
            <div v-if="show" class="mt-3">
                <loading-animation :active.sync="loadingReferencias" :is-full-page="false" :opacity="1" color="#5895ff" />
                <b-table :fields="[
                    {
                        key: 'protocolo',
                        label: $t('Detalhes'),
                    },
                    {
                        key: 'cadastrado',
                        label: $t('Data'),
                    },
                    {
                        key: 'status_nome',
                        label: $t('Status'),
                    },
                    {
                        key: 'actions',
                        label: '',
                        class: 'text-right no-print',
                        thStyle: { width: '95px', minWidth: '95px' },
                    },
                ]" :items="referenciasList" :responsive="true" striped hover show-empty small outlined stacked="md"
                    table-class="mb-3">
                    <template v-slot:cell(protocolo)="data">
                        Usuário(s):<br />
                        <ul>
                            <li v-for="pessoa in data.item.pessoas_objetos" :key="pessoa.id">
                                <strong v-html="
                                    $options.filters.highlight(
                                        pessoa.nome_completo,
                                        search
                                    )
                                "></strong>
                            </li>
                        </ul>

                        Protocolo:
                        <strong v-html="
                            $options.filters.highlight(
                                data.item.protocolo,
                                search
                            )
                        "></strong>
                        <br />
                        <span v-if="data.item.unidade">
                            Origem:
                            <strong v-html="
                                $options.filters.highlight(
                                    data.item.unidade.nome,
                                    search
                                )
                            "></strong>
                        </span>
                        <br />

                        <span v-if="data.item.user.name">
                            Técnico:
                            <strong v-html="
                                $options.filters.highlight(
                                    data.item.user.name,
                                    search
                                )
                            "></strong>
                        </span>
                        <br />
                        <span v-if="data.item.unidade_destino">
                            Unidade de Intervenção:
                            <strong v-html="
                                $options.filters.highlight(
                                    data.item.unidade_destino.nome,
                                    search
                                )
                            "></strong>
                        </span>
                        <br />
                        <span v-if="data.item.user_destino">
                            Técnico na Unidade de Intervenção:
                            <strong v-html="
                                $options.filters.highlight(
                                    data.item.user_destino.nome,
                                    search
                                )
                            "></strong>
                        </span>
                        <br />
                        Tipo:
                        <b v-if="data.item.tipo_nome == 'REFERÊNCIA'">
                            <span class="badge badge-primary">
                                {{ data.item.tipo_nome }}
                            </span>
                        </b>
                        <b v-else>
                            <span class="badge badge-info">
                                {{ data.item.tipo_nome }}
                            </span>
                        </b>
                    </template>
                    <template v-slot:cell(cadastrado)="data">
                        {{ data.item.cadastrado }}
                    </template>
                    <template v-slot:cell(status_nome)="data">
                        <span class="small" v-html="data.item.status_nome"></span>
                    </template>
                    <template v-slot:cell()="data">
                        <b-button v-if="
                            unidade_id == data.item.unidade_id ||
                            unidade_id == data.item.unidade_destino_id
                        " :title="$t('Visualizar e Imprimir')" :to="
    '/dashboard/referenciamentos/show/' +
    data.item.id
" class="px-2 mb-0" size="xs" type="button" v-b-tooltip.hover variant="primary">
                            <i class="mdi mdi-eye" />
                        </b-button>
                    </template>
                    <template v-slot:empty="scope">
                        <div class="text-center my-5">
                            <img :alt="$t('No results')" class="mb-5" src="/img/icons/robot.svg"
                                style="max-height: 165px" />
                            <h3 class="bold">
                                {{ $t("No records found") }}
                            </h3>
                        </div>
                    </template>
                </b-table>

                <b-pagination v-if="pagination.total > perPage" :per-page="perPage" :total-rows="pagination.total"
                    @change="changePage" v-model="page" align="right" pills />
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            referenciasList: [],
            page: 1,
            show: false,
            search: "",
            perPage: 5,
            loadingReferencias: true,
            loading: true,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            user_id: null,
            tecnico_id: null,
            unidade_id: null,
        };
    },
    mounted() {
        // this.getReferencias();
    },

    methods: {
        getReferencias() {
            this.loadingReferencias = true;
            axios
                .get("api/analytics/referenciamentos/report", {
                    params: {
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                    },
                })
                .then((response) => {
                    this.user_id = this.$store.state.user.id;
                    this.tecnico_id = this.$store.state.user.tecnico.id;
                    this.user_id = this.$store.state.user.id;
                    this.unidade_id = this.$store.state.unidade;
                    this.referenciasList = response.data.data;
                    this.pagination = response.data.pagination;

                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getReferencias();
                    } else {
                        this.loadingReferencias = false;
                    }
                })
                .catch(() => {
                    this.loadingReferencias = false;
                });
        },
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getReferencias();
            }
        },
    },
};
</script>

<style></style>
